import { createRoute } from '@tanstack/react-router';
import { IconPackage } from '@tabler/icons-react';
import type { EzyModule } from '../module';
import { JobList } from './JobList';
import { JobDetailPage } from './JobDetailPage';
import { JobNewPage } from './JobNewPage';
import { jobApiRoute } from './apiRoute';
import { JOBS } from './fixtures';
import { JOB_DETAILS } from './detail';

const jobs: EzyModule = {
  nav: { key: 'job', label: 'Job', icon: IconPackage, items: [{ key: 'jobs', label: 'Danh sách Job', to: '/ezy/jobs' }, { key: 'booking', label: 'Booking', to: '/ezy/booking' }] },
  routes: (parent) => [
    createRoute({ getParentRoute: () => parent, path: '/jobs', component: JobList }),
    createRoute({ getParentRoute: () => parent, path: '/jobs/new', component: JobNewPage }),
    createRoute({ getParentRoute: () => parent, path: '/jobs/$jobId', component: JobDetailPage }),
  ],
  api: { job: jobApiRoute },
  fixtures: (register) => {
    register('job', JOBS);
    register('jobDetail', JOB_DETAILS);
  },
};
export default jobs;
